import React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";

import EditIcon from "@material-ui/icons/Edit";
import "./style.css";
import { getTableData } from "./action";
import { connect } from "react-redux";

const ResortList = (props) => {
  const useStyles = makeStyles((theme) =>
    createStyles({
      table: {
        minWidth: 400,
      },
      tableContainer: {
        marginTop: 50,
      },
      root: {
        display: "flex",
      },

      textColor: {
        color: "#ffffff",
      },
      iconColor: {
        color: "#ffffff",
      },
      // necessary for content to be below app bar
      toolbar: theme.mixins.toolbar,
      content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
      },
    })
  );

  const classes = useStyles();
  function selectCheck(e) {
    [].forEach.call(document.querySelectorAll(".item"), function (el) {
      el.style.display = "table-row";
    });
    var select = document.getElementById("activeSelect");
    var value = select.options[select.selectedIndex].value;

    // console.log("value",value)
    // if(value =="yes"){

    // }else{

    // }

    // console.log("props.tabledataList",props.tabledataList)
    //codde
    var status = value === "yes" ? true : false;
    var inputs = document.getElementsByClassName("myCheck");
    for (let index = 0; index < inputs.length; ++index) {
      if (value === "none") {
        break;
      }
      if (inputs[index].hasAttribute("checked") === status) {
        inputs[index].style.display = "table-row";
      } else {
        inputs[index].closest(".item").style.display = "none";
      }
    }
  }

  function filterTable(event, index) {
    var filter = event.target.value.toUpperCase();

    var rows = document.querySelector("#myTable tbody").rows;
    console.log("rows", rows);
    for (var i = 0; i < rows.length; i++) {
      var x = rows[i].cells[0].checked;
      console.log("xxxxxxxxxxxxxxx", x);
      var check = rows[i].cells[0].textContent.toUpperCase();

      var property = rows[i].cells[1].textContent.toUpperCase();
      var roomtype = rows[i].cells[2].textContent.toUpperCase();
      var marshacode = rows[i].cells[3].textContent.toUpperCase();
      var roompool = rows[i].cells[4].textContent.toUpperCase();
      var hotelcode = rows[i].cells[5].textContent.toUpperCase();
      var hotelname = rows[i].cells[6].textContent.toUpperCase();
      var reservationtype = rows[i].cells[7].textContent.toUpperCase();
      var rateprogram = rows[i].cells[8].textContent.toUpperCase();
      var priority = rows[i].cells[9].textContent.toUpperCase();
      var notes = rows[i].cells[10].textContent.toUpperCase();
      if (
        (check.indexOf(filter) > -1 && index === 0) ||
        (property.indexOf(filter) > -1 && index === 1) ||
        (roomtype.indexOf(filter) > -1 && index === 2) ||
        (marshacode.indexOf(filter) > -1 && index === 3) ||
        (roompool.indexOf(filter) > -1 && index === 4) ||
        (hotelcode.indexOf(filter) > -1 && index === 5) ||
        (hotelname.indexOf(filter) > -1 && index === 6) ||
        (reservationtype.indexOf(filter) > -1 && index === 7) ||
        (rateprogram.indexOf(filter) > -1 && index === 8) ||
        (priority.indexOf(filter) > -1 && index === 9) ||
        (notes.indexOf(filter) > -1 && index === 10)
      ) {
        rows[i].style.display = "";
      } else {
        rows[i].style.display = "none";
      }
    }
  }

  document.querySelectorAll(".w3-input").forEach(function (el, idx) {
    el.addEventListener(
      "keyup",
      function (e) {
        filterTable(e, idx);
      },
      false
    );
  });
  return (
    <>
      <Paper className={classes.tableContainer}>
        <table
          className={classes.table}
          id="myTable"
          class="w3-table w3-striped w3-hoverable"
        >
          <thead>
            <tr>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#67b7f7 ",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Active
              </td>
              <td
                style={{
                  color: "#242021",
                  fontWeight: "bold",
                  backgroundColor: "#67b7f7 ",
                  textOrientation: "upright",
                }}
              >
                {" "}
                Sun Property
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#67b7f7 ",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Sun Room Type
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                Marsha code
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Marsha Room Pool
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                Marsha Mini Hotel Code
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                Marsha Mini Hotel Name
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Reservation Type
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#83c3f7",
                  fontWeight: "bold",
                }}
              >
                Marsha Rate Program
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#a6d4fa",
                  fontWeight: "bold",
                }}
              >
                Mini Hotel Priority
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#a6d4fa",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Notes
              </td>
              <td
                style={{
                  color: "#242021",
                  backgroundColor: "#a6d4fa",
                  fontWeight: "bold",
                }}
              >
                {" "}
                Edit
              </td>
            </tr>
          </thead>
          <tr>
            {" "}
            <td>
              {/* <input
                style={{ width: "100%" }}
                id="check"
                class="w3-input"
                placeholder="search"
              /> */}
              <select id="activeSelect" onChange={selectCheck} class="w3-input">
                <option selected value="none">
                  none
                </option>
                <option value="yes">yes</option>
                <option value="no">no</option>
              </select>
            </td>
            <td>
              <input
                style={{ width: "110%" }}
                id="sunproperty"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "120%" }}
                id="roomtype"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "120%" }}
                id="marshacode"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "120%" }}
                id="roompool"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "120%" }}
                id="hotelcode"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "120%" }}
                id="hotelname"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "100%" }}
                id="reservationtype"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "100%" }}
                id="rateprogram"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "100%" }}
                id="priority"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td>
              <input
                style={{ width: "110%" }}
                id="notes"
                class="w3-input"
                placeholder="search"
              />
            </td>
            <td></td>
          </tr>

          <tbody>
            {props.tabledataList.length !== 0 && props.tabledataList
              ? props.tabledataList.map((user) => (
                  <tr key={user.id} class="item" id={user.activeFlag}>
                    <td>
                      <input
                        type="checkbox"
                        className="myCheck"
                        readOnly="1"
                        checked={user.activeFlag}
                      ></input>
                    </td>
                    <td>{user.sunPropertyID}</td>

                    <td>{user.sunRoomType}</td>
                    <td>{user.marshaCode}</td>
                    <td>{user.marshaRoomPool}</td>
                    <td>{user.marshaMiniHotelCode}</td>
                    <td>{user.marshaMiniHotelName}</td>
                    <td>{user.reservationType}</td>
                    <td>{user.marshaRateProgram}</td>
                    <td>{user.miniHotelPrioirty}</td>
                    <td>
                      {" "}
                      <span
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "30px",
                        }}
                      >
                        {user.notes}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <Button
                        onClick={() => {
                          props.editRow(user);
                        }}
                        // color="primary"
                      >
                        <EditIcon></EditIcon>
                      </Button>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </Paper>
      {/* <TablePagination
        rowsPerPageOptions={[2, 5, 7]}
        component="div"
        count={props.users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "rows per page" },
          native: true,
        }}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    tabledataList: state.tabledataList.tableList,
  };
};
export default connect(mapStateToProps, {
  getTableData,
})(ResortList);
